import { Button, Grid } from '@mui/material';
import { SahinModal } from '@sahinyazilim/sahinyazilim-components';
import { SelectFile } from 'common/components/SelectFile/SelectFile';
import { SelectFileRef } from 'common/components/SelectFile/SelectFile.types';
import { SahinTextField } from 'common/components/TextField/SahinTextField';
import { postAPI, updateAPI } from 'common/helper/apiHelpers';
import { getCdnImageUrl } from 'common/utils/image';
import { forwardRef, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { mutate } from 'swr';
import { COMPONENT_TABLE_PATH } from '../List/SliderList';
import { SliderFormYup } from './SliderForm.types';

export const SliderForm = forwardRef<any, any>(
  ({ initialData, open, handleClose, currentPage = 1, perPage = 15 }, ref) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
      setValue,
      reset,
    } = useForm<Slider>({
      resolver: SliderFormYup,
      mode: 'onBlur',
    });

    const { t } = useTranslation();
    const { branchId } = useParams<{ branchId: string }>();

    const fileManager = useRef<SelectFileRef>(null);

    useEffect(() => {
      reset(initialData || {});
    }, [initialData, reset]);

    const onSubmit = async (data: Slider) => {
      const fileUpload = await fileManager.current?.fileUpload();
      if (!fileUpload) return;
      data.image = fileUpload?.[0]?.path;
      data.branch = branchId;

      let promise;
      if (initialData?.id) {
        promise = updateAPI(COMPONENT_TABLE_PATH, initialData.id, data);
      } else {
        promise = postAPI(COMPONENT_TABLE_PATH, data);
      }
      promise.then(() => {
        // Sadece mevcut sayfa ve üst sayfaları temizle
        const cacheKeys = [];
        for (let i = currentPage + 1; i <= 10; i++) {
          // Varsayılan olarak 10 sayfa
          const cacheUrl = `${COMPONENT_TABLE_PATH}?page=${i}&per_page=${perPage}&branch=${branchId}`;
          cacheKeys.push(cacheUrl);
        }

        // Mevcut sayfa fetch edilsin
        const currentUrl = `${COMPONENT_TABLE_PATH}?page=${currentPage}&per_page=${perPage}&branch=${branchId}`;
        mutate(currentUrl);
        // Üst sayfalar sadece cache temizlensin
        cacheKeys.forEach((key) => mutate(key, undefined, false));
        handleClose();
      });
    };

    return (
      <SahinModal
        open={open}
        handleClose={handleClose}
        width="50%"
        height="50%"
      >
        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
          <Grid sx={{ height: '100%' }} container>
            <Grid alignContent="flex-start" spacing={3} container>
              <Grid xs={12} item>
                <SelectFile
                  {...register('image')}
                  ref={fileManager}
                  containerProps={{ width: '100%' }}
                  onChange={(images) => {
                    initialData.image = images[0];
                    setValue('image', images[0]);
                  }}
                  error={errors?.image?.message as string}
                  previewValue={
                    initialData?.image
                      ? [getCdnImageUrl(initialData.image)]
                      : []
                  }
                  value={initialData?.image ? [initialData.image] : []}
                  showPreview
                />
              </Grid>
              <Grid xs={12} item>
                <SahinTextField
                  {...register('url')}
                  error={errors?.url?.message}
                  label={t('link')}
                  placeholder={t('linkPlaceholder')}
                  helperText={t('slider.linkHelperText')}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} justifyContent="flex-end" item container>
                <Button variant="contained" type="submit">
                  {initialData?.id ? t('edit') : t('add')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </SahinModal>
    );
  },
);
